import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Row } from "react-bootstrap";
import { maybe } from "shared/maybe";
import { STANDARD_SPACING } from "../config.js";
import FormFeedback from "./FormFeedback.js";
import { DEFAULT_COL_SIZINGS } from "./index.js";
export default function FormRow(props) {
    const colSizing = { ...DEFAULT_COL_SIZINGS, ...props };
    return (_jsxs(Form.Group, { as: Row, className: "mb-" + STANDARD_SPACING, children: [maybe(props.label, label => {
                return (_jsxs(Form.Label, { column: true, xs: colSizing.xs, sm: colSizing.sm, md: colSizing.md, lg: colSizing.lg, xl: colSizing.xl, xxl: colSizing.xxl, children: [label, ":"] }));
            }), _jsxs(Col, { children: [props.children, _jsx(FormFeedback, { field: props.field })] })] }));
}
